import LegalLayout, { LegalSection } from "../components/LegalLayout";

export default function Impressum() {
  return (
    <LegalLayout eyebrow="Rechtliches" title="Impressum">
      <LegalSection title="Angaben gemäß § 5 DDG">
        <p>
          Vintage Billard
          <br />
          Inhaber: Ahmed Murat
          <br />
          Hemelinger Heerstraße 7
          <br />
          28309 Bremen
        </p>
      </LegalSection>

      <LegalSection title="Kontakt">
        <p>
          Telefon:{" "}
          <a href="tel:+4917632526128" data-testid="impressum-phone" className="text-[#e3c988] underline decoration-[#c9a24a]/40 underline-offset-4 hover:text-[#c9a24a]">
            0176 32526128
          </a>
          <br />
          E-Mail:{" "}
          <a href="mailto:vintagebillard@gmail.com" data-testid="impressum-mail" className="text-[#e3c988] underline decoration-[#c9a24a]/40 underline-offset-4 hover:text-[#c9a24a]">
            vintagebillard@gmail.com
          </a>
        </p>
      </LegalSection>

      <LegalSection title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
        <p>
          Ahmed Murat
          <br />
          Anschrift wie oben
        </p>
      </LegalSection>

      <LegalSection title="Haftung für Inhalte">
        <p>
          Die Inhalte dieser Seiten wurden mit Sorgfalt erstellt. Für Richtigkeit, Vollständigkeit
          und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als
          Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen
          Gesetzen verantwortlich.
        </p>
      </LegalSection>

      <LegalSection title="Haftung für Links">
        <p>
          Diese Website enthält Links zu externen Websites Dritter (z. B. Google Maps), auf deren
          Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der
          jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
